<table>
    <thead>
        <tr>
            <th class="subtable icon"></th>
            <th class="subtable short">{{ 'mantenimientoDenominaciones.proteccion.table.titular' | translate }}</th>
            <th class="subtable short">{{ 'mantenimientoDenominaciones.proteccion.table.ambito' | translate }}</th>
            <th class="subtable short">{{ 'global.estado' | translate }}</th>
            <th class="subtable short">{{ 'global.fecha.inicioVigencia' | translate }}</th>
            <th class="subtable short">{{ 'global.fecha.finVigencia' | translate }}</th>
            <th class="subtable actions">
                <!-- Oculto si ya hay 1 protección -->
                <i *ngIf="!protecciones || (protecciones && protecciones.length < 1)" class="fas fa-plus" title="{{'mantenimientoDenominaciones.proteccion.table.titleNew' | translate}}"
                (click)="showNewProteccion()"></i>
            </th>
        </tr>
    </thead>
    <tbody>
        <app-new-edit-proteccion 
            class="component-in-row" 
            *ngIf="newProteccion" 
            [proteccion]="null"
            [denominacionId]="denominacionId"
            (refresh)="hideNewProteccion($event)"
            (mensaje)="pushMessage($event)">
        </app-new-edit-proteccion>
        <app-new-edit-proteccion 
            class="component-in-row" 
            *ngFor="let proteccion of protecciones; let i = index;" 
            [proteccion]="proteccion"
            [denominacionId]="denominacionId"
            (refresh)="hideNewProteccion($event)"
            (mensaje)="pushMessage($event)">
        </app-new-edit-proteccion>
    </tbody>
    <tfoot *ngIf="!protecciones || (protecciones && protecciones.length < 1)">
        <tr>
            <td colspan="7">
                {{ 'global.noContent' | translate }}
            </td>
        </tr>
    </tfoot>
</table>

<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>